import styled from '@emotion/styled';
import { FC } from 'react';
import tw from 'twin.macro';

import { DashBoard } from '@/views/settlement/purchaseBySales/DashBoard';
import { List } from '@/views/settlement/purchaseBySales/List';

interface IPropsPurchaseBySalesDetail {
  /** partner settlement id */
  partnerId: string;
}
/** style */
const Wrapper = styled.div`
  ${tw`gm-h-full gm-flex gm-flex-col`}
`;

/** component: 월별 정산내역 > 판매분사입 상세 */
const PurchaseBySalesDetail: FC<IPropsPurchaseBySalesDetail> = ({ partnerId }) => {
  return (
    <Wrapper>
      <DashBoard partnerId={partnerId} />
      <List partnerId={partnerId} />
    </Wrapper>
  );
};

export default PurchaseBySalesDetail;
